export const ATTACH_PARENT_REQUEST = "ATTACH_PARENT_REQUEST";
export const ATTACH_PARENT_SUCCESS = "ATTACH_PARENT_SUCCESS";
export const ATTACH_PARENT_FAIL = "ATTACH_PARENT_FAIL";

export const CLEAR_STATE_ATTACH_PARENT = "CLEAR_STATE_ATTACH_PARENT";
export const CLEAR_ERROR_ATTACH_PARENT = "CLEAR_ERROR_ATTACH_PARENT";
